//@flow
import { Paper } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from 'react-i18next'
import { TABLE_COMPONENT } from "../../../../../locales/components/namespaces";
import Pagination from "../pagination/pagination";
import ContentLoader from "../../../../general/contentLoader/contentLoader";
import Grid from '@mui/material/Grid2';

type Props = {
	usingInfiniteScroll?: boolean,
	noMeta?: boolean,
	noPagination?: boolean,
	renderRow: Function,
	initialState: {
		pageIndex: number,
		pageSize: number,
	}
}

const UnstructuredTableView = (props: Props) => {
	const { t } = useTranslation(TABLE_COMPONENT)
	const {
		usingInfiniteScroll,
		noPagination,
		noMeta,
		renderRow,
		loading,
		onPageSizeChange,
		pageCount: controlledPageCount,
	} = props
	const {
		prepareRow,
		page,
		canPreviousPage,
		canNextPage,
		nextPage,
		previousPage,
		setPageSize,
		pageIndex,
		pageSize
	} = props.table
	return (
		<Grid container spacing={2}>
			{page.map((row, index, array) => {
				prepareRow(row)
				return renderRow(row, index, array)
			})}
			<Grid size={12}>
				{loading ?
					<ContentLoader
						loading={loading}
						useCircularLoader
					/>
					: page.length > 0 ?
						!noMeta && !usingInfiniteScroll && (
							<span>
                                {t('Showing')} {page.length} {t('of')} ~{controlledPageCount * pageSize}{' '}
								{t('results')}
                            </span>
						)
						: (
							<Paper>
								<Typography
									component={'div'}
									variant={'body1'}
									sx={{
										textAlign: 'center', color: '#000000', justifySelf: 'center', lineHeight: '3.375', padding: 1
									}}
								>
									{t('no_results')}
								</Typography>
							</Paper>
						)
					
				}
			</Grid>
			<Grid size={12}>
				{!noPagination && !usingInfiniteScroll && (
					<Pagination
						pageSize={pageSize}
						setPageSize={(size) => {
							setPageSize(size)
							if (onPageSizeChange) {
								onPageSizeChange(size)
							}
						}}
						canPreviousPage={canPreviousPage}
						canNextPage={canNextPage}
						nextPage={nextPage}
						pageIndex={pageIndex}
						previousPage={previousPage}
					/>
				)}
			</Grid>
		</Grid>
	)
}

export default UnstructuredTableView